const {
  GET_ALL_SOUSCLIENT_REQUEST,
  GET_ALL_SOUSCLIENT_SUCCESS,
  GET_ALL_SOUSCLIENT_FAIL,
  ADD_SOUSCLIENT_REQUEST,
  ADD_SOUSCLIENT_SUCCESS,
  ADD_SOUSCLIENT_FAIL,
  UPDATE_SOUSCLIENT_REQUEST,
  UPDATE_SOUSCLIENT_SUCCESS,
  UPDATE_SOUSCLIENT_FAIL,
  DELETE_SOUSCLIENT_REQUEST,
  DELETE_SOUSCLIENT_SUCCESS,
  DELETE_SOUSCLIENT_FAIL
} = require("../../actionTypes/Paramaetrage/SousClient");

function getAllSousClients(state = { data: {} }, action) {
  switch (action.type) {
    case GET_ALL_SOUSCLIENT_REQUEST:
      return { loading: true, data: {} };
    case GET_ALL_SOUSCLIENT_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_ALL_SOUSCLIENT_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addSousClient(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_SOUSCLIENT_REQUEST:
      return { loading: true, data: {} };
    case ADD_SOUSCLIENT_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_SOUSCLIENT_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateSousClient(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_SOUSCLIENT_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_SOUSCLIENT_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_SOUSCLIENT_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteSousClient(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_SOUSCLIENT_REQUEST:
      return { loading: true, data: {} };
    case DELETE_SOUSCLIENT_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_SOUSCLIENT_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

export { addSousClient, updateSousClient, deleteSousClient, getAllSousClients };
